import React from "react";
import clsx from "clsx";

const Spinner = () => (
  <svg
    className='animate-spin h-5 w-5 text-white'
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'>
    <circle
      className='opacity-25'
      cx='12'
      cy='12'
      r='10'
      stroke='currentColor'
      strokeWidth='4'
    />
    <path
      className='opacity-75'
      fill='currentColor'
      d='M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z'
    />
  </svg>
);

const Button = ({
  variant = "main",
  size = "md",
  className = "",
  startIcon,
  endIcon,
  children,
  disabled = false,
  ...props
}) => {
  const variantClassMap = {
    main: "btn-main",
    secondary: "btn-secondary",
    inactive: "btn-inactive",
    confirm: "btn-confirm",
    danger: "btn-danger",
  };

  const sizeClassMap = {
    sm: "text-sm px-4 py-2 w-[260px]",
    md: "text-base px-5 py-3 w-[280px]",
    lg: "text-lg px-6 py-4 w-[300px]",
  };  

  return (
    <button
      type='button'
      className={clsx(
        "inline-flex items-center justify-center gap-2 transition-all duration-150 ease-in-out",
        variantClassMap[variant],
        sizeClassMap[size],
        {
          "opacity-50 cursor-not-allowed": disabled,
        },
        className
      )}
      disabled={disabled}
      {...props}>
      {disabled ? (
        <Spinner />
      ) : (
        <>
          {startIcon && (
            <span className='flex-shrink-0 flex items-center justify-center'>
              {startIcon}
            </span>
          )}
          <span className='block text-center leading-tight'>{children}</span>
          {endIcon && (
            <span className='flex-shrink-0 flex items-center justify-center'>
              {endIcon}
            </span>
          )}
        </>
      )}
    </button>
  );
};

export default Button;
